import { Box, Stack, useTheme } from "@compass/core";
import { AppTopBarBrand } from "./AppTopBarBrand";
import { AppTopBarManual } from "./AppTopBarManual";
import { AppTopBarNavTrigger } from "./AppTopBarNavTrigger";
import { AppTopBarSearch } from "./AppTopBarSearch";
import { AppTopBarUserMenu } from "./AppTopBarUserMenu";
import { useMediaQuery } from "@mui/material";
import { AppTopBarNotifications } from "./AppTopBarNotifications/AppTopBarNotifications";
import { AppTopBarTexting } from "./AppTopBarTexting";
import { LkReactMenuId, Permission, PermissionAction } from "generated/openApi";
import { useAppSelector } from "hooks";

export const AppTopBar = () => {
  const theme = useTheme();
  const showSearch = useMediaQuery(theme.breakpoints.up("sm"));
  const reactMenus = useAppSelector((state) => state.app.reactMenus);
  const rolePermissions = useAppSelector((state) => state.app.rolePermissions);
  const canViewTexting =
    reactMenus?.some((menu) => menu.id === Number(LkReactMenuId.Texting_Conversations)) === true &&
    rolePermissions?.some(
      (rolePermission) =>
        rolePermission.permission === Permission.Texting &&
        rolePermission.actions?.includes(PermissionAction.View)
    ) === true;

  return (
    <Stack
      direction="row"
      alignItems="center"
      position="relative"
      px={3}
      py={1}
      bgcolor={theme.palette.background.default}
    >
      <Box sx={{ flex: 1, display: "flex", alignItems: "center" }}>
        <AppTopBarNavTrigger />
        <AppTopBarBrand />
        <AppTopBarManual />
      </Box>

      {showSearch && (
        <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
          <Box sx={{ width: "100%", maxWidth: 500 }}>
            <AppTopBarSearch />
          </Box>
        </Box>
      )}

      <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
        {canViewTexting && <AppTopBarTexting />}
        <AppTopBarNotifications />
        <AppTopBarUserMenu />
      </Box>
    </Stack>
  );
};
